import './config';
import './bad-css-organization-hook.css';
import 'regenerator-runtime/runtime';
import workLogActivity from './work-log-activity';
import workLogEditor from './work-log-editor';


angular.module(module.exports = 'ttb.issue.workLogDetails', [
    'ttb.core',
    'ttb.helpers',
    workLogActivity,
    workLogEditor,
]);



// WEBPACK FOOTER //
// ./components/index.js